import BaseStore from '@src/utils/store/base-store';
import Video from '@src/components/video';
import PopMiniModalStore from '@src/business-components/pop-mini-modal/store';
import PopMiniModal from '@src/business-components/pop-mini-modal';
import RegisterModalStore from '@src/business-components/register-modal/store';
import RegisterModal from '@src/business-components/register-modal';
import useModal from '@src/utils/hooks/use-modal';
import { noop } from '@src/utils/common-util';
import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import $$tracker from '@src/tracker';
function generateUUID() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 16; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

class FirstScreenStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  // 当前页面尺寸
  @observable currentPageWidth = window.innerWidth;

  @observable currentPageHeight = window.innerHeight;

  // 背景图适应模式：'width-fit' 根据宽度适应，'height-fit' 根据高度适应
  @observable backgroundFitMode = 'height-fit';

  @observable videoPlayState = false;

  @observable isActive = false;

  @observable videoClose = noop;

  // 游戏下载链接
  @observable
  downloadHref = 'https://ssglauncher.xoyocdn.com/ssglauncher/ssg/Client/prod/Channel/MechaBREAKCN/SeasunGameInstaller-MechaBREAKCN-mechabreak_cn.exe';

  // 下载文件名
  @observable downloadName = 'SeasunGameInstaller-MechaBREAKCN-mechabreak_cn.exe';

  // 背景图片加载完成
  @observable loadedBg = false;

  // 初始下载链接
  initDownloadHref = () => {
    // 实现获取广告类型参数的方法
    let ads_adstype = '';
    if (typeof window !== 'undefined' && window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      ads_adstype = params.get('ads_adstype') || '';
    }

    let downUuid = localStorage.getItem('downUuid');
    if (!downUuid) {
      downUuid = generateUUID();
      localStorage.setItem('downUuid', downUuid);
    }
    if (ads_adstype) {
      this.downloadName = `SeasunGameInstaller-MechaBREAKCN-mechabreak_cn-AT=${ads_adstype}-AC=${downUuid}`;
      this.downloadHref = `https://ssglauncher.xoyocdn.com/ssglauncher/ssg/Client/prod/Channel/MechaBREAKCN/SeasunGameInstaller-MechaBREAKCN-mechabreak_cn-AT=${ads_adstype}-AC=${downUuid}.exe`;
    }
  };

  // 计算背景图适应模式
  calculateBackgroundFitMode = () => {
    // 背景图的实际尺寸，您可以根据实际背景图尺寸调整这些值
    const backgroundImageWidth = 2560; // 背景图实际宽度
    const backgroundImageHeight = 1200; // 背景图实际高度

    // 计算在高度适应模式下，背景图的显示宽度
    const backgroundDisplayWidth = (backgroundImageWidth * this.currentPageHeight) / backgroundImageHeight;

    // 当页面宽度超过背景图在高度适应模式下的显示宽度时，使用宽度适应
    if (this.currentPageWidth > backgroundDisplayWidth) {
      this.backgroundFitMode = 'width-fit';
    } else {
      this.backgroundFitMode = 'height-fit';
    }
  };

  // 处理页面尺寸变化
  handleResize = () => {
    this.currentPageWidth = window.innerWidth;
    this.currentPageHeight = window.innerHeight;
    this.calculateBackgroundFitMode();
  };

  // 绑定页面尺寸监听
  bindResizeListener = () => {
    window.addEventListener('resize', this.handleResize);
    // 初始计算
    this.handleResize();
  };

  // 解绑页面尺寸监听
  unbindResizeListener = () => {
    window.removeEventListener('resize', this.handleResize);
  };

  // 组队微信小程序二维码弹窗
  openPopMiniModal = () => {
    this.popMiniModal.open();
  };

  // 注册表单弹窗
  openRegisterModal = () => {
    this.registerModal.open();
  };

  // 视屏播放
  onVideoPlay = () => {
    $$tracker.clickVideo();
    const videoLink = 'https://static-omni-mechabreak.seasungames.cn/uploads/202511/S3FAB%E8%B5%9B%E5%AD%A3%E6%AD%A6%E8%A3%85.mp4';
    this.videoPlayState = true;
    const { close: videoClose } = Video.append({
      src: videoLink,
      onCloseCallBack: () => {
        this.videoPlayState = false;
      }
    });
    this.videoClose = videoClose;
  };

  // 组队微信小程序二维码弹窗
  @observable popMiniModalStore = new PopMiniModalStore();
  @observable popMiniModal = undefined;

  // 注册表单弹窗
  @observable registerModalStore = new RegisterModalStore();
  @observable registerModal = undefined;

  use() {
    super.use();
    this.popMiniModal = useModal(PopMiniModal, { store: this.popMiniModalStore });
    this.registerModal = useModal(RegisterModal, { store: this.registerModalStore });

    useMount(() => {
      this.initDownloadHref();
      this.bindResizeListener();
    });
    return () => {
      this.videoClose?.();
      this.unbindResizeListener();
    };
  }
}

export default FirstScreenStore;
